import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';

const Checkbox = (props) => <Input {...props} type="checkbox" />;

Checkbox.propTypes = {
  /* Id will be used for the label htmlFor and input id attributes */
  id: PropTypes.string.isRequired,

  /* Callback for the onChange event of the input */
  onChange: PropTypes.func.isRequired,

  /* Render function for label content */
  labelContent: PropTypes.func,

  /* Triggers disabled state on input and corresponding styles for label */
  isDisabled: PropTypes.bool,

  /* Muted style - similar to disabled but still selectable */
  isMuted: PropTypes.bool,

  /* Alternative layout with label on the left of the input, currently only used for mobile web */
  isLabelLeft: PropTypes.bool,

  /* Layout with label on the left of the input on mobile */
  isLabelLeftOnMobile: PropTypes.bool,

  /* Maps to input checked attribute */
  isChecked: PropTypes.bool,

  /* Maps to input name attribute */
  name: PropTypes.string,
};

Checkbox.defaultProps = {
  isDisabled: false,
  isMuted: false,
  isLabelLeft: false,
  isLabelLeftOnMobile: false,
  name: undefined,
  isChecked: false,
  labelContent: undefined,
};

export default Checkbox;
